import { useQuery } from '@tanstack/react-query';
import { fetchAllWarehouses } from '../DirectoriesPage/WarehousesPage/services';

export const useWarehouses = () => {
  const { data: warehouses, isLoading } = useQuery({
    queryKey: ['warehouses'],
    queryFn: fetchAllWarehouses,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
  return { warehouses, isLoading };
};
